import { Checkbox } from "@progress/kendo-react-inputs";
import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
// import cellDetailContractsHistory from "./cellDetailContractsHistory";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import "./configuration-contracts-history-panel.pure.css";


const formatNumberWithCommas = (number) => {
  if (number != null) {
    return number.toLocaleString();
  }
  return number;
};

const resolveField = (dataItem, fieldPath) => {
  // Verifica si fieldPath es realmente una cadena
  if (typeof fieldPath !== 'string') {
    console.error('El campo debe ser una cadena. Recibido:', fieldPath);
    return undefined; // O puedes devolver un valor por defecto
  }

  // Divide la ruta por el punto (.)
  const fields = fieldPath.split('.');

  // Accede al objeto de forma dinámica
  return fields.reduce((obj, field) => (obj ? obj[field] : undefined), dataItem);
};

const SignRequestCell = (props) => {
  const cellItemStyles = {
    color: "#123513",
    fontSize: "15px",
    fontFamily: "Quicksand",
    flexDirection: "column",
  };

  // Usa la función resolveField para acceder a los valores anidados
  const formattedValue = formatNumberWithCommas(resolveField(props.dataItem, props.field));
  const title = props.title;

  return (
    <td style={cellItemStyles}>
      <div style={{
        color: '#2c353c',
        fontFamily: 'Quicksand',
        fontSize: '14px',
        fontWeight: 700,
        letterSpacing: '-0.28px',
        lineHeight: '28px',
        margin: '-15px -24px',
        padding: '16px 24px',
        textAlign: 'end'
      }} >{title}</div>
      <div>{formattedValue}</div>
    </td>
  );
};


const DetailsTypeContract = (props) => {

  const { t } = useTranslation();
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const gridSignatureRequestPanelStyle = {
    left: "-5px",
  };

  // const checkedContrato =
  //   props.dataItem.contractServices &&
  //   props.dataItem.contractServices.find(
  //     (contract) => contract.service.name === "Plan contratos"
  //   );
  // const checkedBoveda =
  //   props.dataItem.contractServices &&
  //   props.dataItem.contractServices.find(
  //     (contract) => contract.service.name === "Bóveda Digital"
  //   );

  const checkedContrato =
    props.dataItem?.planLevel?.key === "planGrcHibou" ||
    props.dataItem?.planLevel?.key === "planGrcContracts";
  const checkedBoveda =
    props.dataItem?.planLevel?.key === "planGrcHibou" ||
    props.dataItem?.planLevel?.key === "planGrcDigitalVault";

  const renderSwitch = (contractType) => {
    switch (contractType.name) {
      case "Subscripción Mensual":
        return (
          <p>
            <strong>
              Creditos mensuales Consumidos/Incluidos:{" "}
              <span>{props.dataItem.availableTransaction}</span>
            </strong>
          </p>
        );
      case "Prepago anual":
        return (
          <p>
            <strong>
              Creditos Consumidos/Incluidos:{" "}
              <span> {props.dataItem.availableTransaction}</span>
            </strong>
          </p>
        );
      // case null:
      //   return " ";

      default:
        return (
          <>
            <Grid
              className="configurationContractsHistoryPanelPure-historic-plans detailTypeContract"
              data={[props.dataItem]}
              style={gridSignatureRequestPanelStyle}
              resizable
              reorderable
            >
              <GridColumn
                headerClassName="align-left-header"
                className={`${isSmallScreen ? "vertical-on-small" : ""} align-left`}
                cell={(props) => {
                  const startDate = props.dataItem.createdDate;
                  const endDate = props.dataItem.endOfContract;
                  return (
                    <div className={`custom-responsive-date-global ${isSmallScreen ? 'custom-vertical' : ''}`}>
                      <div className='custom-date-global'>
                        <span className="custom-date-label">{t("configurationSignatureHistoryPanel.dateStart")}</span>
                        <span className="custom-date-style">{startDate}</span>
                      </div>
                      <div className='custom-date-global'>
                        <span className="custom-date-label">{t("configurationSignatureHistoryPanel.dateEnd")}</span>
                        <span className="custom-date-style">{endDate}</span>
                      </div>
                    </div>
                  );
                }}
              />

              {
                !isSmallScreen && (
                  <GridColumn
                    cell={(props) => (
                      <SignRequestCell {...props} field="totalTransaction" title={" "} />
                    )}
                  />
                )
              }
              {
                !isSmallScreen && (
                  <GridColumn
                    cell={(props) => {
                      return (
                        <SignRequestCell {...props} field="totalCreditsUsed.signRequest" title="(2-1)" />
                      )
                    }}
                  />
                )
              }
              {
                !isSmallScreen && (
                  <GridColumn
                    cell={(props) => (
                      <SignRequestCell {...props} field="totalCreditsUsed.govoAuth" title="(2-1)" />
                    )}
                  />
                )
              }
              {
                !isSmallScreen && (
                  <GridColumn
                    cell={(props) => (
                      <SignRequestCell {...props} field="totalCreditsUsed.apiCall" title="(4-1)" />
                    )}
                  />
                )
              }
              {
                !isSmallScreen && (
                  <GridColumn
                    cell={(props) => (
                      <SignRequestCell {...props} field="totalCreditsUsed.ocr" title="(4-1)" />
                    )}
                  />
                )
              }
              {
                !isSmallScreen && (
                  <GridColumn
                    cell={(props) => (
                      <SignRequestCell {...props} field="totalCreditsUsed.ia" title="(4-1)" />
                    )}
                  />
                )
              }

              <GridColumn
                cell={(props) => <SignRequestCell {...props} field="saldo" title={t("configurationSignatureHistoryPanel.balance")} />}
                className={isSmallScreen ? "vertical-on-small" : ""}
              />

              {/* {!isSmallScreen && (
                      <GridColumn
                        field="actions"
                        title={"Acciones"}
                        cell={cellDetailContractsHistory(
                          props.buttonClass,
                          t("configurationSignatureHistoryView.btnRequestInvoice"),
                          t("configurationSignatureHistoryView.buttonDetail"),
                          props.view
                        )}
                      />
                    )} */}

              <GridNoRecords>
                <span style={{ color: "#2C353C", fontSize: "16px", fontWeight: 600, fontFamily: "Quicksand", display: 'flex', justifyContent: 'center' }}>
                  {t("signatureRequestPanelPure2.notResults")}
                </span>
              </GridNoRecords>
            </Grid>
            {/* <strong className='DetailsTypeContract-details-plans-checks-consumos-span'>
              Creditos Consumidos/Pagados:{" "}
              <span>{props.dataItem.totalTransaction}</span>
            </strong> */}
          </>
        );
    }
  };

  return (
    <section className="DetailsTypeContract-detail-contract-type">

      <div className="DetailsTypeContract-details-plans-checks">
        {props.dataItem.contractType !== null
          ? renderSwitch(props.dataItem.contractType)
          : null}
        {props.dataItem.contractType &&
          props.dataItem.contractType.name === "Subscripción Mensual" ? (
          <p>
            <strong>
              Consumos adicionales:{" "}
              <span className="DetailsTypeContract-details-plans-checks-consumos-span">
                {props.dataItem.additionalTransaction}
              </span>{" "}
            </strong>
          </p>
        ) : null}
      </div>
    </section>
  );
};

export { DetailsTypeContract as default };
